import { config } from "../../../../frontend.config";

export const localization: LocalizationConfig = {
    available: config.locales,
    locales: {
        en: {
            fonts: {
                primaryFont: "mocoSans",
                secondaryFont: "mocoDisplay",
            },
        },
        fr: {
            fonts: {
                primaryFont: "mocoSans",
                secondaryFont: "mocoDisplay",
            },
        },
        de: {
            fonts: {
                primaryFont: "mocoSans",
                secondaryFont: "mocoDisplay",
            },
        },
        it: {
            fonts: {
                primaryFont: "mocoSans",
                secondaryFont: "mocoDisplay",
            },
        },
        ja: {
            fonts: {
                primaryFont: "mocoSans",
                secondaryFont: "mocoDisplay",
                titleBoldValue: "bold",
            },
        },
        ko: {
            fonts: {
                primaryFont: "mocoSans",
                secondaryFont: "mocoDisplay",
                titleBoldValue: "bold",
            },
        },
        pl: {
            fonts: {
                primaryFont: "mocoSans",
                secondaryFont: "mocoDisplay",
            },
        },
        pr: {
            fonts: {
                primaryFont: "mocoSans",
                secondaryFont: "mocoDisplay",
            },
        },
        ru: {
            fonts: {
                primaryFont: "NotoSans",
                primaryFontRatio: 1,
                secondaryFont: "NotoSans",
                titleBoldValue: 700,
            },
        },
        es: {
            fonts: {
                primaryFont: "mocoSans",
                secondaryFont: "mocoDisplay",
            },
        },
        tr: {
            fonts: {
                primaryFont: "mocoSans",
                secondaryFont: "mocoDisplay",
            },
        },
        zh: {
            fonts: {
                primaryFont: "mocoSans",
                secondaryFont: "mocoDisplay",
                titleBoldValue: "bold",
            },
        },
        "zh-hans": {
            fonts: {
                primaryFont: "mocoSans",
                secondaryFont: "mocoDisplay",
                titleBoldValue: "bold",
            },
        },
    },
};
